import {
  bulkUploadJobTranslations,
  bulkUploadJobs,
  downloadJobTranslationsBulkUploadTemplate,
  downloadJobsBulkUploadTemplate,
} from "../../../../services/jobs/jobs";
import BulkUploadSection from "../../../../components/bulk_upload/bulk_upload_section";
import BulkUploadDialogShell from "../../../../components/bulk_upload/bulk_upload_dialog_shell";

interface BulkUploadJobsDialogProps {
  open: boolean;
  onClose: () => void;
}

export default function BulkUploadJobsDialog({ open, onClose }: BulkUploadJobsDialogProps) {
  return (
    <BulkUploadDialogShell
      open={open}
      onClose={onClose}
      title="Bulk Upload Jobs"
      createTabLabel="Create Jobs"
      translationsTabLabel="Add Translations"
      createTabContent={
        <BulkUploadSection
          description="Upload an .xlsx file to create many jobs at once, in English. Download the template first for the exact column format and the valid names for Job Type, Category, Sub Category, Experience, Salary Range, etc."
          templateFileName="jobs_bulk_upload_template.xlsx"
          onDownloadTemplate={downloadJobsBulkUploadTemplate}
          onUpload={bulkUploadJobs}
          savedLabel="created"
          listQueryKey="JobList"
        />
      }
      translationsTabContent={
        <BulkUploadSection
          description="Upload an .xlsx file to add translations to existing jobs - one row per Job ID + language. Find a job's ID on the Jobs list or its details page."
          templateFileName="job_translations_bulk_upload_template.xlsx"
          onDownloadTemplate={downloadJobTranslationsBulkUploadTemplate}
          onUpload={bulkUploadJobTranslations}
          savedLabel="saved"
          listQueryKey="JobList"
        />
      }
    />
  );
}
